import { NameEntity } from './name.model';

export interface VendorItem {
  id: number,
  status: number,
  email: string,
  vendorName: string,
  userId: number,
}

export interface UserEntity {
  id: number;
  email: string;
  fullName: string;
  countryCode?: string | null;
  phoneNeedsReview?: boolean;
  firstName: string;
  lastName: string;
  username: string;
  cartId: string;
  phone: {
    phoneNumber: string;
  };
  phoneNumber: string;
  roles: string[];
  signUpType: string;
  status: number;
  isRestrictedAdmin: boolean;
}

export interface UserAdminCreate {
  username: string;
  email: string;
  password: string;
  fullName?: string;
  countryCode?: string | null;
  firstName?: string;
  lastName?: string;
  role?: number;
  status: number;
  isRestrictedAdmin: boolean;
}

export interface VendorInfo {
  vendorName: string;
  status: number;
}

export type UserVendorCreate = VendorInfo & {
  email: string;
  password: string;
};

export type UserVendorUpdate = Partial<UserVendorDetail>;

export interface UserVendorDetail {
  id: number;
  userId: number;
  vendorName: string;
  email: string;
  password: string;
  status: number;
}

export interface VendorProductsEntity {
  id: number;
  name: NameEntity;
  price: number;
}

export interface UserCustomerCreate {
  phoneNumber: string;
  email?: string;
  fullName?: string;
  countryCode?: string | null;
  firstName?: string;
  lastName?: string;
  status: number;
}

export type UserAdminUpdate = Partial<UserAdminCreate> & { id: number; roles?: number[] };
export type UserCustomerUpdate = Partial<UserCustomerCreate> & { id: number };

export interface UserDelete {
  userIds: number | number[];
  role?: number;
}

export interface UserChangeStatus {
  ids: number[];
  status: 1 | 0;
}

export interface CustomerAddressEntity {
  address?: string;
  id: number;
  governorateId: number;
  areaId: number;
  governorate: { id: number; name: NameEntity };
  area: { id: number; name: NameEntity };
  street: string;
  avenue: string;
  floor: string;
  apartment: string;
  lat: number;
  long: number;
  houseType: AddressHouseType;
  buildingNumber: string;
  block: string;
  name: string;
}

export type CustomerAddressUpdate = {
  customerId: number;
  addressId: number;
  updateFields: Partial<CustomerAddressEntity>;
};

export type CustomerAddressCreate = {
  fields: Partial<CustomerAddressEntity>;
  customerId: number;
};

export type GovernorateArea = { name: string; id: number };

export interface EditProfile {
  phoneNumber?: string | number | null;
  email?: string | null;
  fullName?: string | null;
  countryCode?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  status?: string | null;
  password?: string | null;
  defaultAddressId?: number | null;
}

export enum AddressHouseType {
  'House',
  'Building'
}
